// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__cymzx","description":"PatientConsentPreview_description__3jXbB"};